import { doesAiAnalysisHasAnyUpdates } from '@aibees/elephant/components/person-ai-analysis-info/utils';
import { PeopleTableInfo } from '@aibees/elephant/feature/search-table-people';
import { doesContactDetailHaveAnyUpdates } from '@aibees/elephant/feature/search-table-people/components/people-drawer/components/contact-details/utils';
import { isEmailBelongsToPreviousCompanies } from '@aibees/elephant/feature/search-table-people/components/people-email-popover/utils';
import { doesEmailEnrichmentHaveAnyUpdates } from '@aibees/elephant/feature/search-table-people/components/people-quick-info/utils';
import { ROUTES } from '@aibees/elephant/router';
import { useMemo } from 'react';

export type PersonUpdatesData = {
  hasAnyUpdates: boolean;
  hasProfileUpdates: boolean;
  profileUpdatesCount: number;
  hasEmailUpdates: boolean;
  emailUpdatesCount: number;
  hasAiAnalysisUpdates: boolean;
  aiAnalysisUpdatesCount: number;
  totalUpdatesCount: number;
  updatePathRoute: string;
  needToCheckForUpdates: boolean;
};

export function getPersonUpdatesData(
  data?: PeopleTableInfo
): PersonUpdatesData {
  const hasProfileUpdates = doesContactDetailHaveAnyUpdates(data);
  const profileUpdatesCount = data?.changes?.CONTACT?.length ?? 0;

  const hasEmailUpdates = doesEmailEnrichmentHaveAnyUpdates(data);
  const needToCheckForUpdates = isEmailBelongsToPreviousCompanies(data);
  const emailUpdatesCount = hasEmailUpdates || needToCheckForUpdates ? 1 : 0;

  const hasAiAnalysisUpdates = doesAiAnalysisHasAnyUpdates(data);
  const aiAnalysisUpdatesCount = hasAiAnalysisUpdates
    ? data?.changes?.ANALYSIS?.length ?? 0
    : 0;

  const hasAnyUpdates =
    hasProfileUpdates ||
    hasEmailUpdates ||
    hasAiAnalysisUpdates ||
    needToCheckForUpdates;

  const totalUpdatesCount =
    profileUpdatesCount + emailUpdatesCount + aiAnalysisUpdatesCount;

  const updatePathRoute =
    profileUpdatesCount > 0
      ? ROUTES.peopleUpdatesProfile
      : emailUpdatesCount > 0
      ? ROUTES.peopleUpdatesContact
      : aiAnalysisUpdatesCount > 0
      ? ROUTES.peopleUpdatesAnalysis
      : ROUTES.peopleUpdatesProfile;

  return {
    hasAnyUpdates,
    hasProfileUpdates,
    profileUpdatesCount,
    hasEmailUpdates,
    emailUpdatesCount,
    hasAiAnalysisUpdates,
    aiAnalysisUpdatesCount,
    totalUpdatesCount,
    updatePathRoute,
    needToCheckForUpdates,
  };
}

export function useGetPersonUpdatesData(data?: PeopleTableInfo) {
  return useMemo(() => getPersonUpdatesData(data), [data]);
}
